<template>
    <div class="meta--nav">
        <nav>
            <ul>
                <li><a href="tel:+4922739537362"><svg-vue icon="support-headphones" class="icon"/><translate>+ 49 (0) 2273 95 373 62</translate></a></li>
                <li v-if="this.$page.url.startsWith('/login')  && isClient">
                    <Link :href="$$route('register.email')"><svg-vue icon="lock-shield-prote" class="icon"/><translate>Registrieren</translate></Link>
                </li>
                <li v-if="this.$page.url.startsWith('/register')">
                    <Link :href="$$route('login')"><svg-vue icon="lock-shield-prote" class="icon"/><translate>Login</translate></Link>
                </li>
                <li>
                    <language-selector />
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>

import { Link } from '@inertiajs/vue3';
import LanguageSelector from '@partfactory/Shared/LanguageSelector';

export default {
    name: 'MetaNav',
    components: {
        LanguageSelector,
        Link
    },
    computed: {
        isClient() {
            return this.$page.props.routePrefix === 'client';
        }
    }
};
</script>
